import { FC, useEffect, useState } from "react";
import { Select } from "../OldSelect";

import styles from "./styles.module.scss";

type MonthPickerProps = {
    value?: string;
    onChange?: (value: string) => void;
    fromYear?: number;
    toYear?: number;
    className?: string;
    error?: string;
};

const MONTHS = [
    "Janvier",
    "Février",
    "Mars",
    "Avril",
    "Mai",
    "Juin",
    "Juillet",
    "Août",
    "Septembre",
    "Octobre",
    "Novembre",
    "Décembre",
];

const MonthPicker: FC<MonthPickerProps> = ({
    value,
    onChange,
    fromYear = 2000,
    toYear = new Date().getFullYear() + 10,
    className,
    error,
}) => {
    // Parse YYYY-MM
    const initialYear = value
        ? Number(value.split("-")[0])
        : new Date().getFullYear();
    const initialMonth = value
        ? Number(value.split("-")[1])
        : new Date().getMonth() + 1;

    const [selectedYear, setSelectedYear] = useState(initialYear);
    const [selectedMonth, setSelectedMonth] = useState(initialMonth);

    useEffect(() => {
        if (value) {
            const [y, m] = value.split("-");
            setSelectedYear(Number(y));
            setSelectedMonth(Number(m));
        }
    }, [value]);

    const emitChange = (year: number, month: number) => {
        if (onChange) {
            const formatted = `${year}-${String(month).padStart(2, "0")}`;
            onChange(formatted);
        }
    };

    const handleMonthChange = (month: string) => {
        setSelectedMonth(Number(month));
        emitChange(selectedYear, Number(month));
    };

    const handleYearChange = (year: string) => {
        setSelectedYear(Number(year));
        emitChange(Number(year), selectedMonth);
    };

    return (
        <div className={`${className} ${styles.monthPicker}`}>
            <Select
                value={String(selectedMonth)}
                onChanged={(value) => handleMonthChange(value as string)}
                className={styles.selectMonth}
                error={error}
            >
                {MONTHS.map((label, idx) => (
                    <option key={idx + 1} value={idx + 1}>
                        {label}
                    </option>
                ))}
            </Select>
            <Select
                value={String(selectedYear)}
                onChanged={(value) => handleYearChange(value as string)}
                className={styles.selectYear}
                error={error}
                showErrorMessage={false}
            >
                {Array.from(
                    { length: toYear - fromYear + 1 },
                    (_, i) => fromYear + i
                ).map((year) => (
                    <option key={year} value={year}>
                        {year}
                    </option>
                ))}
            </Select>
        </div>
    );
};

export default MonthPicker;
